import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const trendingArticles = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);

export default function TrendingList() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              热门榜单
            </h2>
            <p className="text-sm text-foreground-600">最受读者欢迎的欧美一区内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trendingArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-white rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all duration-300 cursor-pointer relative"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute top-3 left-3 w-8 h-8 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-sm">
                {index + 1}
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700">
                    {article.category === 'movies-tv' ? '影视' :
                     article.category === 'music' ? '音乐' :
                     article.category === 'variety' ? '综艺' :
                     article.category === 'documentary' ? '纪录片' :
                     article.category === 'fashion' ? '时尚' : '体育'}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}